import { Stack, Typography, Snackbar, Alert, Box } from "@mui/material";

import { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import { ReactComponent as IconWallet } from "../../images/iconWallet.svg";

import Timer from "../../components/Timer";
import Condutas from "../PrimeiraConsulta/modulos/Conduta/index";

import {
  requestAnamneseReavaliacao,
  requestExamesEProcedimentos,
  requestCondutaConclusaoEncaminhamentos,
  requestAnamneseDadosGerais,
} from "../../services/cadastroService";

import {
  dadosIniciais,
  examesPredefinidosOptions,
  examesPredefinidosList,
} from "./dadosIniciais";

import CardPaciente from "../../components/CardPaciente";
import api from "../../services/api";
import inserirExamesSalvos from "../PrimeiraConsulta/inserirExamesSalvos";
import AnamneseGeral from "../PrimeiraConsulta/modulos/AnamneseGeral";
import { insertAnamneseGeral, insertAvaliacao } from "./inserirRespostasSalvas";
import ButtonGoBack from "../../components/Buttons/outlinedGoback";
import AvaliacaoReavaliacao from "./Modulos/AvaliacaoReavaliacao";
import ExamesProcedimentos from "./Modulos/ExamesProcedimentos";
import ModalDialogs from "../../components/ModalDialogs";
import { ErrorMessageServeDefault } from "../../utils/mensagensSistema";
import Loading from "../../components/Loading";
import { getItemDecrypt } from "../../utils/cryptoData";
import {
  simOuNaoOptions,
  statusCognitivoOptions,
} from "../PrimeiraConsulta/dadosIniciais";
import dayjs from "dayjs";
import { formatarPeso } from "../PrimeiraConsulta/inserirRespostasSalvas";

const styles = {
  title: {
    fontWeight: "300",
    fontSize: "32px",
    lineHeight: "25px",
    color: "#063F5E",
  },
  formTitle: {
    fontFamily: "Nunito",
    fontSize: "26px",
    fontWeight: 600,
    lineHeight: "35px",
    letterSpacing: "0em",
    textAlign: "left",
    color: "#063F5E",
  },
  subtitle: {
    fontFamily: "Nunito",
    fontSize: "20px",
    fontWeight: 500,
    lineHeight: "27px",
    color: "#737373",
  },
};

let id_consulta;
let id_consulta_evolucao;

export default function ConsultaDemaisProfissionais() {
  let vinculo = getItemDecrypt("vinculo_ativo");
  const location = useLocation();
  const queryString = location.search;
  const params = new URLSearchParams(queryString);
  const isMultidisciplinar = params.get("multidisciplinar") === "true";

  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [pesoHabitual, setPesoHabitual] = useState(0);
  const [dadosIniciaisState, setDadosIniciaisState] = useState(dadosIniciais);
  const [value, setValue] = useState(0);
  const [idConsultaEvolucao, setIdConsultaEvolucao] = useState(0);

  const [time, setTime] = useState(0);
  const [isRunning, setIsRunning] = useState(true);
  const [snackbar, setSnackbar] = useState(null);

  const [open, setOpen] = useState(false);
  const [openFinalizar, setOpenFinalizar] = useState(false);
  const [openSalvar, setOpenSalvar] = useState(false);
  const [openCancelar, setOpenCancelar] = useState(false);
  const handleOpen = () => setOpen(true);
  const [consultaAgendada, setConsultaAgendada] = useState(null);

  const handleClose = () => {
    setOpen(false);
    setOpenSalvar(false);
    setOpenFinalizar(false);
    setOpenCancelar(false);
  };

  const homeIn = () => {
    navigate("/home");
  };

  const handleCancelarConsulta = () => {
    const CANCELADA = 4;
    atualizaStatusConsulta(idConsultaEvolucao, CANCELADA, vinculo.id);

    navigate("/home");
  };

  const [expanded, setExpanded] = useState(false);

  const handleChangePanel = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    let intervalId;
    if (isRunning) {
      intervalId = setInterval(() => setTime(time + 1), 1000);
    }
    return () => clearInterval(intervalId);
  }, [isRunning, time]);

  const hours = Math.floor(time / 3600); // Calcula as horas
  const minutes = Math.floor((time / 60) % 60); // Calcula os minutos corretamente
  const seconds = Math.floor(time % 60); // Calcula os segundos

  useEffect(() => {
    setDadosIniciaisState((prevState) => ({
      ...prevState,
      idPaciente: id,
      idVinculo: vinculo.id,
      nu_consulta: 2,
      isMultidisciplinar: isMultidisciplinar,
    }));
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const rotaValida = await validaRota();
      const rotaValidaConsulta = await validaRotaConsulta();
      if (rotaValida && rotaValidaConsulta) {
        await iniciarPrimeiraConsulta();
        await exibirRespostasSalvas();
        await getExames();
        await getPeso();
      }
    } catch (error) {
      console.error("An error occurred during data fetching:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  async function validaRotaConsulta() {
    try {
      if (isMultidisciplinar) {
        const consultaAgendada = await getConsultaAgendada();
        return consultaAgendada;
      } else {
        return true;
      }
    } catch (error) {
      console.error("Error ao validar consulta:", error.message);
      setSnackbar({
        children: "Erro ao validar consulta. Tente novamente mais tarde.",
        severity: "error",
      });
      return false;
    }
  }

  const getConsultaAgendada = async () => {
    try {
      const { data } = await api.get(`agenda-paciente/${id}`, {
        params: {
          is_paciente: true,
          status: "1,2",
          data: dayjs().format("YYYY-MM-DD"),
        },
      });
      if (data.length > 0) {
        const response = data[0];
        if (response) {
          const consultaEvo = response.consultas_evoloucao.find(
            (consulta) => consulta.id_vinculo === vinculo.id
          );
          if (!consultaEvo) {
            setSnackbar({
              children:
                "Não existe consulta agendada para hoje. Vocé sera redirecionado para o Prontuário do paciente.",
              severity: "error",
            });
            setTimeout(() => {
              navigate(`/pacientes/prontuario/${id}`);
            }, 5000);
            return false;
          }
          id_consulta = response.id;
          id_consulta_evolucao = consultaEvo.co_id;
          setConsultaAgendada(response);
          setIdConsultaEvolucao(consultaEvo.co_id);
          setDadosIniciaisState((prevState) => ({
            ...prevState,
            idPaciente: id,
            id_consulta: response.id,
            id_consulta_evolucao: consultaEvo.co_id,
            isMultidisciplinar: true,
            idVinculo: vinculo.id,
          }));
          atualizaStatusConsulta(consultaEvo.co_id, 2, vinculo.id);

          return true;
        }
      }
      setSnackbar({
        children:
          "Não existe consulta agendada para hoje. Você sera redirecionado para o Prontuário do paciente.",
        severity: "error",
      });
      setTimeout(() => {
        navigate(`/pacientes/prontuario/${id}`);
      }, 5000);

      return false;
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
      return false;
    }
  };

  const validaRota = async () => {
    try {
      //Se profissional é neurologista, o retorno da requisição é true
      //Caso contrário, é false
      const { data } = await api.post(`/checar-perfil-profissional/`, {
        id_vinculo: vinculo.id,
      });

      if (data) {
        navigate(`/pacientes/primeira-consulta/${id}`);
      }
      return true;
    } catch (error) {
      setSnackbar({
        children: ErrorMessageServeDefault,
        severity: "error",
      });
      console.error("Ocorreu um erro:", error.message);
      return false;
    }
  };

  const getRespostasAnaminese = async (id_consulta) => {
    if (!id_consulta || id_consulta === "") {
      return [];
    }
    const response = await api.get(`/anaminese/${id_consulta}/`);
    if (response.data) {
      if (response.data.hasOwnProperty("error")) {
        setSnackbar({
          children: response.data.error,
          severity: "warning",
        });
        return [];
      } else {
        return response.data.respostas;
      }
    }
    return [];
  };
  const getRespostasOutherExams = async (idConsultaEvolucao) => {
    if (!idConsultaEvolucao || idConsultaEvolucao === "") {
      return {};
    }
    const response = await api.get(`/outros-exames/${idConsultaEvolucao}`);
    if (response.data) {
      const solicitacaoOutrosExames = response.data.map((item) => {
        return {
          tipoExame: item.no_tipo_exame,
          modeloExame: item.no_modelo_exame,
          descricaoSolicitacaoExame: item.no_descricao_exame.replace(
            /\r\n|\r/g,
            "\n"
          ),
        };
      });
      return {
        solicitacaoOutrosExames: solicitacaoOutrosExames,
      };
    }
    return {};
  };

  const iniciarPrimeiraConsulta = async () => {
    try {
      if (!isMultidisciplinar) {
        const response = await api.post("/consulta/", {
          data: {
            id_paciente: parseInt(id),
            id_vinculo: vinculo.id,
            respostas: [],
          },
        });
        if (response.data.hasOwnProperty("error")) {
          throw new Error();
        }
        setIdConsultaEvolucao(response.data.consultaEvolucao.co_id);
        id_consulta = response.data.idConsulta;
        setDadosIniciaisState((prevState) => ({
          ...prevState,
          idPaciente: id,
          idVinculo: vinculo.id,
          id_consulta: response.data.idConsulta,
          id_consulta_evolucao: response.data.consultaEvolucao.co_id,
        }));
      } else {
        const exames = await getRespostasOutherExams(id_consulta_evolucao);
        const data = await getRespostasAnaminese(id_consulta);
        const contextdata = {
          ...exames,
          idPaciente: id,
          idVinculo: vinculo.id,
          nu_consulta: 2,
          id_consulta: id_consulta,
          id_consulta_evolucao: id_consulta_evolucao,
          isMultidisciplinar: isMultidisciplinar,
        };

        insertAnamneseGeral(data, contextdata);

        console.log(contextdata);

        setDadosIniciaisState((prevState) => ({
          ...prevState,
          ...contextdata,
        }));
      }
    } catch (error) {
      console.error("Erro ao buscar respostas:", error);

      setSnackbar({
        children:
          "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde.",
        severity: "error",
      });
    }
  };

  async function getPeso() {
    try {
      const { data } = await api.post("/pegar-resposta", {
        id_paciente: id,
        id_pergunta: 53,
      });

      if (data !== "") {
        setPesoHabitual(parseFloat(data.replace(",", ".")));
      } else {
        const { data } = await api.post("/pegar-resposta", {
          id_paciente: id,
          id_pergunta: 9,
        });

        setPesoHabitual(parseFloat(data.replace(",", ".")));
      }
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  async function getRespostasPrimeiraConsulta() {
    try {
      const { data } = await api.post("respostas-consulta", {
        id_paciente: id,
        id_vinculo: vinculo.id,
      });

      return data;
    } catch (error) {
      setSnackbar({
        children: ErrorMessageServeDefault,
        severity: "error",
      });
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getExames() {
    try {
      const examesSalvos = await getExamesPrimeiraConsulta();

      if (examesSalvos.length !== 0) {
        inserirExamesSalvos(
          examesSalvos,
          dadosIniciaisState,
          setDadosIniciaisState
        );
      }
    } catch (error) {
      setSnackbar({
        children: ErrorMessageServeDefault,
        severity: "error",
      });
      console.error(error);
    }
  }

  async function exibirRespostasSalvas() {
    const respostas = await getRespostasPrimeiraConsulta();
    const data = {};
    insertAvaliacao(respostas, data);
    setDadosIniciaisState((prevState) => ({
      ...prevState,
      ...data,
    }));
  }
  const isFieldRequiredEmpyt = () => {
    var camposObrigatorios = [
      dadosIniciaisState.anamnese,
      dadosIniciaisState.sintomasEQueixas,
    ];

    for (const campo of camposObrigatorios) {
      if (campo === "") {
        setSnackbar({
          children: "Existem campos obrigatórios que não foram preenchidos",
          severity: "warning",
        });
        return true;
      }
    }
    return false;
  };
  const handleSalvarTudo = () => {
    if (!isFieldRequiredEmpyt()) {
      handleSubmit("salvar-tudo");
    }
  };

  const handleFinalizar = () => {
    if (!isFieldRequiredEmpyt()) {
      handleSubmit("salvar-tudo", true);
      setOpen(false);
    }
  };

  async function atualizaStatusConsulta(
    id_consulta_evolucao,
    id_status,
    id_vinculo
  ) {
    try {
      if (isMultidisciplinar) {
        //Atualizar consulta multidisciplinar
        await api.put("/consulta-multi-update", {
          id_consulta_evolucao,
          id_status,
          id_vinculo,
        });
      } else {
        await api.put("/consulta/", {
          id_consulta_evolucao,
          id_status,
          id_vinculo,
        });
      }
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function handleSubmit(event, finalizaConsulta = false) {
    if (event === "salvar-tudo") {
      try {
        await requestAnamneseReavaliacao(dadosIniciaisState);
        await requestAnamneseDadosGerais(dadosIniciaisState);
        await requestCondutaConclusaoEncaminhamentos(dadosIniciaisState);
        await requestExamesEProcedimentos(dadosIniciaisState);

        if (finalizaConsulta && idConsultaEvolucao) {
          const FINALIZADA = 3;
          atualizaStatusConsulta(idConsultaEvolucao, FINALIZADA, vinculo.id);
          setOpenFinalizar(true);
        } else {
          setOpenSalvar(true);
        }
        setExpanded("closed");
      } catch (error) {
        setSnackbar({
          children: ErrorMessageServeDefault,
          severity: "error",
        });
        console.error("Ocorreu um erro:", error.message);
      }
      return;
    }

    event.preventDefault();

    let response = null;

    switch (event.nativeEvent.submitter.name) {
      case "dadosGerais":
        response = await requestAnamneseDadosGerais(dadosIniciaisState);
        break;
      case "avaliacaoProcedimentos":
        response = await requestAnamneseReavaliacao(dadosIniciaisState);
        break;
      case "laboratorial":
      case "outrosExames":
        response = await requestExamesEProcedimentos(dadosIniciaisState);
        break;
      case "condutaConclusaoEncaminhamentos":
        response = await requestCondutaConclusaoEncaminhamentos(
          dadosIniciaisState
        );
        break;
      default:
    }

    if (response) {
      setOpenSalvar(true);
      setExpanded("closed");
    }
  }

  async function getExamesPrimeiraConsulta() {
    try {
      const { data } = await api.post("exames-consulta", {
        id_paciente: id,
        id_vinculo: vinculo.id,
        all_exames: true,
      });

      return data;
    } catch (error) {
      setSnackbar({
        children: "Existem campos obrigatórios que não foram preenchidos",
        severity: "warning",
      });
      console.error("Ocorreu um erro:", error.message);
    }
  }

  const handleCheckedField = (e, field) => {
    const { value, checked } = e.target;

    if (dadosIniciaisState[field] === undefined) {
      dadosIniciaisState[field] = [];
    }
    if (checked) {
      setDadosIniciaisState((prevState) => ({
        ...prevState,
        [field]: [...dadosIniciaisState[field], value],
      }));
    } else {
      setDadosIniciaisState((prevState) => ({
        ...prevState,
        [field]: dadosIniciaisState[field].filter((e) => e !== value),
      }));
    }
  };

  const handleExamesPredefinidosOptions = (val) => {
    const value = val;
    if (value === "1") {
      setDadosIniciaisState((prevState) => ({
        ...prevState,
        examesPredefinidosExamesEProcedimentos: [],
      }));
    } else if (value === "2") {
      setDadosIniciaisState((prevState) => ({
        ...prevState,
        examesPredefinidosExamesEProcedimentos: examesPredefinidosList.map(
          (exame) => exame.value
        ),
      }));
    } else if (value === "3") {
      setDadosIniciaisState((prevState) => ({
        ...prevState,
        examesPredefinidosExamesEProcedimentos: ["1", "4", "5", "25", "26"],
      }));
    }

    setDadosIniciaisState((prevState) => ({
      ...prevState,
      examesPredefinidosSelect: value,
    }));
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Box>
      <Box>
        <ButtonGoBack />

        <CardPaciente id={id} />

        <Box mb="50px">
          <Stack
            direction="row"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
              mb: "16px",
            }}
          >
            <Stack>
              <Typography style={styles.formTitle}>
                Consulta em andamento
              </Typography>
              <Typography style={styles.subtitle}>
                Presencial | Multidisciplinar
              </Typography>
            </Stack>

            <Timer
              hours={hours}
              minutes={minutes}
              seconds={seconds}
              setOpenCancelar={setOpenCancelar}
              handleSalvarTudo={handleSalvarTudo}
              handleOpen={handleOpen}
            />
          </Stack>

          <AnamneseGeral
            expanded={expanded}
            handleChangePanel={handleChangePanel}
            onSubmit={handleSubmit}
            data={dadosIniciaisState}
            setData={setDadosIniciaisState}
            pesoHabitual={pesoHabitual}
            simOuNaoOptions={simOuNaoOptions}
            statusCognitivoOptions={statusCognitivoOptions}
          />

          <AvaliacaoReavaliacao
            data={dadosIniciaisState}
            setData={setDadosIniciaisState}
            onSubmit={handleSubmit}
            expanded={expanded}
            handleChangePanel={handleChangePanel}
          />
          <ExamesProcedimentos
            expanded={expanded}
            handleChangePanel={handleChangePanel}
            value={value}
            handleChangeTabs={handleChange}
            onSubmit={handleSubmit}
            data={dadosIniciaisState}
            setData={setDadosIniciaisState}
            handleExamesPredefinidosOptions={handleExamesPredefinidosOptions}
            examesPredefinidosOptions={examesPredefinidosOptions}
            handleCheckedField={handleCheckedField}
            examesPredefinidosList={examesPredefinidosList}
          />
          <Condutas
            expanded={expanded}
            handleChangePanel={handleChangePanel}
            handleSubmit={handleSubmit}
            data={dadosIniciaisState}
            setData={setDadosIniciaisState}
          />
          <ModalDialogs
            open={open}
            onClose={handleClose}
            onActionSecondary={handleClose}
            onActionPrimary={handleFinalizar}
            modalType="warning"
            title={
              <>
                <IconWallet /> Finalizar consulta
              </>
            }
            body="Você realmente deseja finalizar essa consulta?"
            secondaryButtonText="Não"
            primaryButtonText="Sim"
          />
          <ModalDialogs
            open={openCancelar}
            onClose={handleClose}
            onActionSecondary={handleClose}
            onActionPrimary={handleCancelarConsulta}
            modalType="error"
            title={
              <>
                <IconWallet /> Cancelar consulta
              </>
            }
            body="Você realmente deseja cancelar essa consulta?"
            secondaryButtonText="Não"
            primaryButtonText="Sim"
          />

          <ModalDialogs
            open={openFinalizar}
            onClose={handleClose}
            onActionSecondary={() =>
              navigate(`/pacientes/resumo-consulta/${idConsultaEvolucao}`)
            }
            onActionPrimary={homeIn}
            modalType="success"
            title={
              <>
                <IconWallet /> Consulta finalizada
              </>
            }
            body="A consulta foi finalizada com sucesso"
            secondaryButtonText="Resumo da consulta"
            primaryButtonText="Home-in"
          />
          <ModalDialogs
            open={openSalvar}
            onClose={handleClose}
            onActionSecondary={handleClose}
            onActionPrimary={homeIn}
            modalType="success"
            title={
              <>
                <IconWallet /> Dados salvos
              </>
            }
            body={
              <Box sx={{ width: { xs: "100%", sm: "400px" } }}>
                Dados salvos com sucesso
              </Box>
            }
            secondaryButtonText="Permanecer na consulta"
            primaryButtonText="Home-in"
          />
          {!!snackbar && (
            <Snackbar
              open
              onClose={() => {}}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <Alert {...snackbar} onClose={() => setSnackbar(null)} />
            </Snackbar>
          )}
        </Box>
      </Box>
    </Box>
  );
}
